module.exports = __webpack_public_path__ + "img/up.840fd90d.svg";